'use strict';

exports.__esModule = true;
exports['default'] = initAjaxActivity;

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var STATE_LOADING = 'loading';
var STATE_LOADED = 'loaded';
var STATE_CANCELED = 'canceled';
var STATE_TIMEOUT = 'timeout';

var index = 0;
var unique = function unique() {
  return ++index;
};

var defaultOpts = {
  headers: {},
  body: undefined,
  user: undefined,
  password: undefined,
  timeout: 0,
  withCredentials: false,
  tags: [],
  autoRemove: false
};

function initAjaxActivity(pipeline, dispatcher) {
  pipeline.take('requests/*uri', function (context, request) {
    if (!request || !request.method || !request.url) return;

    var uri = context.params.uri;
    var method = request.method;
    var url = request.url;

    var opts = Object.assign({}, defaultOpts, request.opts);

    var id = unique();
    var xhr = new window.XMLHttpRequest();
    var onProgress = function onProgress(ev) {
      return ev.lengthComputable && dispatcher.dispatch(actions.update(id, STATE_LOADING, ev.loaded / ev.total));
    };
    var onAbort = function onAbort() {
      return dispatcher.dispatch(actions.update(id, STATE_CANCELED, null));
    };
    var onTimeout = function onTimeout() {
      return dispatcher.dispatch(actions.update(id, STATE_TIMEOUT, null));
    };
    var onLoadend = function onLoadend() {
      dispatcher.dispatch(actions.update(id, STATE_LOADED, 1.0));
      pipeline.put('responses/' + uri, { method: method, url: url, status: xhr.status, body: xhr.response });
      if (opts.autoRemove) {
        dispatcher.dispatch(actions.remove(id));
      }
    };

    xhr.onprogress = onProgress;
    xhr.onloadend = onLoadend;
    xhr.onabort = onAbort;
    xhr.ontimeout = onTimeout;

    xhr.upload.onprogress = onProgress;
    xhr.upload.onloadend = onLoadend;
    xhr.upload.onabort = onAbort;
    xhr.upload.ontimeout = onTimeout;

    xhr.timeout = opts.timeout;
    xhr.withCredentials = opts.withCredentials;

    dispatcher.dispatch(actions.add(id, STATE_LOADING, 0, opts.tags, xhr));

    xhr.open(method, url, true, opts.user, opts.password);

    for (var key in opts.headers) {
      xhr.setRequestHeader(key, opts.headers[key]);
    }

    xhr.send(opts.body);
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/ajax/activity.js
 ** module id = 115
 ** module chunks = 0
 **/